import store from '@/store'
export default [
  {
    path: '/disciplinary-conditions',
    name: 'disciplinary-condition',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-condition/index.vue')
  },
  {
    path: '/disciplinary-conditions/:id',
    name: 'disciplinary-condition-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-condition/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch(
        'disciplinaryCondition/find',
        to.params.id
      )
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
